import styled from '@emotion/styled';

import { COLOR_TEXT_MUTED } from './utils/variables';

export const MutedText = styled.span`
  color: ${COLOR_TEXT_MUTED};
  font-size: 14px;
`;
